define(['angular'], function(angular) {


    function FilesProvider() {
        var bdcUrl;

        this.setBDCUrl = function setBDCUrl(url) {
            bdcUrl = url;
        };

        this.$get = [
            '$http',
            function($http) {
                var self = {};

                /**
                 * Create or update a groups of stores
                 * @param  {Object} data
                 * @return {Promise}
                 */
                self.getFiles = function getFiles() {
                    return $http.get(bdcUrl + 'files').then(function(res) {
                        return res.data;
                    });
                };

                /**
                 * Create or update a groups of stores
                 * @param  {Object} data
                 * @return {Promise}
                 */
                self.getCategories = function getCategories() {
                    return $http.get(bdcUrl + 'file/categories').then(function(res) {
                        return res.data;
                    });
                };

                return self;
            }
        ];
    }

    angular.module('app.bdc.files.filesProvider', []).provider('files', FilesProvider);
});
